// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"faf0107b","631":"8be604c2"}[chunkId] + ".chunk.js";
};